// HoursReportPage.jsx

// Dependencies
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import PageHeading from '@/components/common/PageHeading';
import HoursReport from '@/components/data/hours/HoursReport';

// Services
import { getAllocationsHoursReport } from '@/services/schedulingService';

// Styling
import { homeCss } from '@digital_monorepo/styling';

const HoursReportPage = () => {
  const { t } = useTranslation();

  const [hoursReport, setHoursReport] = useState(null);
  const [management] = useState(null);
  const [fullTime] = useState(null);

  useEffect(() => {
    async function fetchData() {
      try {
        const hoursReport = await getAllocationsHoursReport(management, fullTime);
        hoursReport.sort((a, b) => a.ProfessionalName.localeCompare(b.ProfessionalName));
        setHoursReport(hoursReport);
      } catch (error) {
        console.error('Error fetching allocations data:', error);
        setHoursReport([
          {
            ProfessionalID: 'T011557',
            ProfessionalName: 'Adriana Colaço Conduto',
            FunctionName: 'Tech Senior 1',
            Office: 'Lisbon Studio',
            ProfessionalNotes: null,
            Skills: null,
            StartDate: '2024-02-26',
            Hours: 40
          }
        ]);
      }
    }
    fetchData();
  }, [management, fullTime]);

  return (
    <div className='workspace-management-page'>
      <PageHeading title='Hours report' />
      <div className={homeCss.mainContent}>{hoursReport && <HoursReport report={hoursReport} />}</div>
    </div>
  );
};

export default HoursReportPage;
